module.exports = {"513334100":"高城镇","513334101":"甲洼镇","513334200":"君坝乡","513334201":"哈依乡","513334202":"觉吾乡","513334203":"莫坝乡","513334204":"亚火乡","513334205":"绒坝乡","513334206":"呷洼乡","513334207":"奔戈乡","513334208":"村戈乡","513334209":"禾尼乡","513334210":"曲登乡","513334211":"喇嘛垭乡","513334212":"章纳乡","513334213":"上木拉乡","513334214":"下木拉乡","513334215":"中木拉乡","513334216":"濯桑乡","513334218":"藏坝乡","513334219":"格木乡","513334220":"拉波乡","513334221":"麦洼乡","513334222":"德巫乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513334.json
// module id = 2425
// module chunks = 0